const BlackHole = ({ unlocked, showAll }) => (
  <div className='weapon'>
    {!showAll && <div className='title'>You should pick Black Hole</div>}
    {showAll && <div className='title'>Black Hole</div>}
  </div>
);

export default BlackHole;
